// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/no-unknown-property */
/** @jsx jsx */
import React from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Accordion,
} from '@chakra-ui/react'
import { MenuButton } from '@theme-ui/components'
import { TiDocumentText } from 'react-icons/ti'
import { jsx } from 'theme-ui'
import { Box, Button, ALink } from '../elements'
import Logo from '../Logo'
import { ChildMenu } from '../sidebar'

export const NavDrawer = ({ items = [], ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()
  return (
    <>
      <MenuButton
        {...props}
        ref={btnRef}
        variantColor="primary"
        onClick={onOpen}
        sx={{ width: 30, height: 30 }}
      >
        Open
      </MenuButton>
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} finalFocusRef={btnRef}>
        <div sx={{ position: 'fixed', zIndex: '100' }}>
          <DrawerOverlay sx={{ bg: 'rgba(0,0,0,0.5)' }} />
          <DrawerContent sx={{ bg: 'white', maxWidth: '20rem' }}>
            <DrawerCloseButton sx={{ position: 'absolute', right: '20px', top: '20px' }} />
            <DrawerHeader sx={{ p: 3 }}>
              <div sx={{ mx: 'auto' }}>
                <Logo />
              </div>
            </DrawerHeader>

            <DrawerBody
              sx={{
                px: 1,
                pt: 3,
                overflowY: 'auto',
              }}
            >
              <Accordion allowToggle allowMultiple>
                {items.map((item, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <ChildMenu key={i} topLevel item={item} />
                ))}
              </Accordion>
              <Box sx={{ 'a, a button': { width: '100%', my: [3], py: 3 } }}>
                <ALink to="/contact">
                  <Button
                    sx={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      ':hover': { color: 'white' },
                      bg: 'primary',
                      fontSize: 2,
                    }}
                  >
                    <TiDocumentText sx={{ mr: [2] }} />
                    REQUEST A FREE ESTIMATE
                  </Button>
                </ALink>
              </Box>
            </DrawerBody>
          </DrawerContent>
        </div>
      </Drawer>
    </>
  )
}

export default NavDrawer
